export default __webpack_public_path__ + "static/media/026-tomatoes.7173a6b0.svg";